import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import styles from './upload-modal.scss';
import FileDropZone from '../../../../../../../../../components/FileDropZone.js';
import closeIcon from '../../../../../../../../../assets/close.svg';
import checkIcon from '../../../../../../../../../assets/check.svg';
import failIcon from '../../../../../../../../../assets/orders-table-reject.svg';
import ReportsService from '../../../../../../../../../services/reports-service.js';

const reportsService = new ReportsService();

const UploadModalContent = ({ context, onClose }) => {
  const { report } = context; // Destructure the context
  const [fileState, setFileState] = useState(null);
  const [uploadFlag, setUploadFlag] = useState(false);
  const [successMessage, setSuccessMessage] = useState({ msg: '', show: false });
  const [errorMessage, setErrorMessage] = useState({ msg: '', show: false });
  const [isMounted, setIsMounted] = useState(false); // Track mounted status

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false); // Cleanup function to set mounted status to false
    };
  }, []);

  const formatDate = (dt) => new Date(dt).toISOString();

  const renderFileDropZone = () => {
    return fileState == null ? (
      <FileDropZone setFileHandler={(file) => {
        // console.log('File received:', file); // Log file details here
        setFileState(file);
      }} />
    ) : (
      <div className='file-detail'>
        <div className='close-icon' onClick={removeFile}>
          <img src={closeIcon} alt="Remove file" />
        </div>
        <div className='details'>
          <div>{fileState.name}</div>
          <div>{formatDate(fileState.lastModified)}</div>
        </div>
      </div>
    );
  };

  const removeFile = () => setFileState(null);

  const uploadFile = () => {
    if (fileState) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64File = reader.result.split(',')[1]; // Extract Base64 part

        if (base64File) {
          // console.log('Base64 File:', base64File); // Log Base64 data

          reportsService.uploadReport(
            report.reportType,
            report.isin,
            report.reportTitle,
            report.issuerRequestDate,
            fileState.name,
            base64File
          )
          .then(response => {
            // console.log('Response:', response);
            if (isMounted) {
              showSuccessMessage('File uploaded successfully!');
            }
          })
          .catch(error => {
            console.error('Upload failed:', error);
            if (isMounted) {
              showErrorMessage('File upload failed!');
            }
          });
        } else {
          console.error('Base64 encoding failed.');
          if (isMounted) {
            showErrorMessage('File encoding failed!');
          }
        }
      };

      reader.onerror = (error) => {
        console.error('Error reading file:', error);
        if (isMounted) {
          showErrorMessage('Error reading file');
        }
      };

      reader.readAsDataURL(fileState); // Convert file to Base64
    }

    setUploadFlag(true);
    const timeoutId = setTimeout(() => {
      if (isMounted) {
        setUploadFlag(false);
      }
    }, 1500);

    // Cleanup the timeout when the component unmounts
    return () => clearTimeout(timeoutId);
  };

  const showSuccessMessage = (msg) => {
    setSuccessMessage({ msg, show: true });
    const timeoutId = setTimeout(() => {
      if (isMounted) {
        setSuccessMessage({ msg: '', show: false });
      }
    }, 3600);

    return () => clearTimeout(timeoutId); // Cleanup the timeout
  };

  const showErrorMessage = (msg) => {
    setErrorMessage({ msg, show: true });
    const timeoutId = setTimeout(() => {
      if (isMounted) {
        setErrorMessage({ msg: '', show: false });
      }
    }, 3600);

    return () => clearTimeout(timeoutId); // Cleanup the timeout
  };

  return (
    <div className='upload-modal-content'>
      <Row>
        {successMessage.show && (
          <div className='success-msg'>
            <img alt="Success" src={checkIcon} /> {successMessage.msg}
          </div>
        )}
        {errorMessage.show && (
          <div className='error-msg'>
            <img alt="Error" src={failIcon} /> {errorMessage.msg}
          </div>
        )}
      </Row>
      <div className='file-upload-area'>{renderFileDropZone()}</div>
      <Row>
        <Col>
          <div className='button-container'>
            <Button onClick={onClose} variant="secondary">
              Close
            </Button>
            <Button
              className={styles['btn']}
              disabled={fileState == null || uploadFlag}
              onClick={uploadFile}
            >
              {uploadFlag ? (
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
              ) : (
                'Upload'
              )}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UploadModalContent;
